import { useState } from 'react';

export function useHistoryPreview<TData>() {
    const [previewData, setPreviewData] = useState<TData>();

    return {
        previewData,
        isPreviewOpen: Boolean(previewData),
        openPreview: (data: TData) => setPreviewData(data),
        closePreview: () => setPreviewData(undefined),
    };
}
